import { render } from "./LostItem.vue?vue&type=template&id=55800fe0"
import script from "./LostItem.vue?vue&type=script&lang=js"
export * from "./LostItem.vue?vue&type=script&lang=js"

import "./LostItem.vue?vue&type=style&index=0&id=55800fe0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__